import React, { useCallback } from 'react'

import type { AdapterKitControlProps } from 'components/formKit/types'
import type { ISelectProps, SelectValueType } from 'components/uiKit/Select'
import Select from 'components/uiKit/Select'

const FieldSelect = <V extends SelectValueType>({
  name,
  onChange,
  ...rest
}: AdapterKitControlProps<ISelectProps<V>, V>) => {
  const handleChange = useCallback((value: V) => onChange({ name, value }), [name, onChange])

  return <Select {...rest} name={name} onChange={handleChange} />
}

export default React.memo(FieldSelect) as typeof FieldSelect
